"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.getPermission = getPermission;
exports.getPermissions = getPermissions;
exports.getRoles = getRoles;
exports.importRoutesPath = importRoutesPath;
exports.updatePermission = updatePermission;
var _request = _interopRequireDefault(require("@/utils/request"));
function getRoles() {
  return (0, _request.default)({
    url: '/roles',
    method: 'get'
  });
}
function importRoutesPath(data) {
  return (0, _request.default)({
    url: '/roles/permissions/import',
    method: 'post',
    data: data
  });
}
function addRole(data) {
  return (0, _request.default)({
    url: '/roles',
    method: 'post',
    data: data
  });
}
function getPermission(roleId) {
  return (0, _request.default)({
    url: "/roles/".concat(roleId),
    method: 'get'
  });
}
function getPermissions() {
  return (0, _request.default)({
    url: "/roles/permissions",
    method: 'get'
  });
}
function updatePermission(roleId, data) {
  return (0, _request.default)({
    url: "/roles/".concat(roleId, "/update"),
    method: 'post',
    data: data
  });
}